export default {
  getPersonalGoalsDatasByMemberid: "BackEnd/getPersonalGoalsDatasByMemberid",
  getMyPersonalGoalsDatas: "BackEnd/getMyPersonalGoalsDatas",
  getgetMyPersonalGoalsDatasDetails:
    "BackEnd/getgetMyPersonalGoalsDatasDetails",
  setPersonalGoalsDatas: "BackEnd/setPersonalGoalsDatas",
  updatePersonalGoalsDatas: "BackEnd/updatePersonalGoalsDatas",

  getDoRateListByMemberid: "BackEnd/getDoRateListByMemberid",
  getMyDoRateList: "BackEnd/getMyDoRateList",
  setDoRate: "BackEnd/setDoRate",
  updateDoRate: "BackEnd/updateDoRate",
};
